import { render, staticRenderFns } from "./UnlayerEditor.vue?vue&type=template&id=3c2f57ee&scoped=true"
import script from "./UnlayerEditor.vue?vue&type=script&lang=js"
export * from "./UnlayerEditor.vue?vue&type=script&lang=js"
import style0 from "./UnlayerEditor.vue?vue&type=style&index=0&id=3c2f57ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2f57ee",
  null
  
)

export default component.exports